import React from "react";

const AboutWelcomeEventDescription = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* 
          PENYESUAIAN TELITI:
          - text-justify: membuat teks rata kanan-kiri
          - leading-loose: memberikan ruang antar baris yang lebih nyaman untuk paragraf panjang
      */}
      <p className="text-slate-600 dark:text-slate-400 text-justify leading-loose text-base md:text-lg">
        Cardiovascular disease (CVD) remains a major global health challenge and
        is responsible for around 38% of total mortality in Indonesia. The rising 
        prevalence of hypertension, diabetes, and lifestyle-related risk factors 
        underscores the urgency to strengthen prevention, early detection, and 
        evidence-based treatment through collaboration and continuous knowledge exchange. 
        As the field of cardiology continues to evolve rapidly, we are called to 
        bridge innovation with clinical skill, research with real-world practice, 
        and technology with the human touch.
      </p>

      <p className="text-slate-600 dark:text-slate-400 text-justify leading-loose text-base md:text-lg">
        This summit brings together cardiologists, healthcare professionals, 
        academics, and medical practitioners to explore the latest advancements 
        in diagnosis, treatment, technology, and management of cardiovascular diseases. 
        Through scientific presentations, expert discussions, and skill-based 
        workshops, we aim to share the latest innovations while fostering 
        meaningful professional partnerships to enhance the quality of 
        cardiovascular care across the nation.
      </p>
    </div>
  );
};

export default AboutWelcomeEventDescription;